export default {
  // False to close and True for open.
  leftHandSideBar: false,
  rightHandSideBar: false
}
